<mat-grid-list [ngClass]="{'darkMode': darkModeService.darkMode}" cols="12" gutterSize="10" rowHeight="40">
  <mat-grid-tile colspan="8" rowspan="2">
    <mat-form-field class="longName">
      <mat-label>{{ "ORG_ADMIN.ORG_NAME" | translate }}</mat-label>
      <input #name="ngModel" name="name" [readonly]="!new" matInput required [(ngModel)]="organization.name" pattern="[a-zA-Z0-9]*"/>
      <mat-error *ngIf="!name.pristine && name.errors">
       Must consist of alphanumeric characters
      </mat-error>
    </mat-form-field>
  </mat-grid-tile>
  <mat-grid-tile colspan="2" rowspan="2">
    <mat-form-field>
      <mat-label>{{ "ORG_ADMIN.SHORT_ORG_NAME" | translate }}</mat-label>
      <input #shortName="ngModel" name="shortName" [readonly]="!new" matInput required [(ngModel)]="organization.shortName" pattern="[a-zA-Z0-9]*" maxlength=6/>
      <mat-error *ngIf="!shortName.pristine && shortName.errors">
        Must consist of alphanumeric characters
      </mat-error>
    </mat-form-field>
  </mat-grid-tile>
  <mat-grid-tile colspan="2" rowspan="2">
    <div>
      <mat-icon *ngIf="orgStatus == 'ON' && !new" [ngClass]="{'power-on-dark': darkModeService.darkMode, 'power-on': !darkModeService.darkMode}" (click)="scaleDownOrganization()" matTooltip='{{ "ORG_ADMIN.ORG_JENKINS_STATUS_ON" | translate }}'>power_settings_new</mat-icon>
      <mat-icon *ngIf="orgStatus == 'OFF' && !new" [ngClass]="{'power-off-dark': darkModeService.darkMode,'power-off': !darkModeService.darkMode}" (click)="scaleUpOrganization()" matTooltip='{{ "ORG_ADMIN.ORG_JENKINS_STATUS_OFF" | translate }}'>power_settings_new</mat-icon>
      <mat-icon *ngIf="orgStatus == 'UNSTABLE' && !new" [ngClass]="{'power-unstable-dark': darkModeService.darkMode,'power-unstable': !darkModeService.darkMode}" matTooltip='{{ "ORG_ADMIN.ORG_JENKINS_STATUS_UNSTABLE" | translate }}'>power_settings_new</mat-icon>
    </div>
  </mat-grid-tile>
  <mat-grid-tile colspan="2" rowspan="2">
    <mat-form-field appearance="fill">
      <mat-label>{{ "ORG_ADMIN.JENKINS_CONFIG" | translate }}</mat-label>
      <mat-select  required *ngIf="new && !edit" [(ngModel)]="jenkinsConfig" name="jenkinsConfig" class="jenkins-config">
          <mat-option *ngFor="let config of infrastructure?.availableJenkinsConfigs" [value]="config">
              {{config}}
          </mat-option>
      </mat-select>
      <input matInput *ngIf="!new && !edit" id="jenkinsConfig" [value]="jenkinsConfig" disabled />

      <mat-select  required *ngIf="!new && edit && globalAdmin" [(ngModel)]="jenkinsConfig" name="jenkinsConfig" id="jenkinsConfig">
        <mat-option *ngFor="let config of infrastructure?.availableUpdateJenkinsConfigs" [value]="config"  id="jenkinsConfig">
            {{config}}
        </mat-option>
      </mat-select>

    </mat-form-field>
  </mat-grid-tile>


  <mat-grid-tile *ngIf="!new && globalAdmin"  colspan="2" rowspan="2">
    <mat-form-field appearance="fill">
      <mat-label>{{ "ORG_ADMIN.JENKINS_SIZE_CONFIG" | translate }}</mat-label>
      <mat-select  required *ngIf="new && !edit" [(ngModel)]="jenkinsSizeConfig" name="jenkinsSizeConfig" class="jenkins-config">
          <mat-option *ngFor="let config of infrastructure?.availableUpdateJenkinsSizesConfigs" [value]="config">
              {{config}}
          </mat-option>
      </mat-select>
      <input matInput *ngIf="!new && !edit" [value]="jenkinsSizeConfig" disabled />

      <mat-select  required *ngIf="!new && edit && globalAdmin" [(ngModel)]="jenkinsSizeConfig" name="jenkinsSizeConfig" id="jenkinsSizeConfig">
        <mat-option *ngFor="let config of infrastructure?.availableUpdateJenkinsSizesConfigs" [value]="config" id="jenkinsSizeConfig">
            {{config}}
        </mat-option>
      </mat-select>

    </mat-form-field>
  </mat-grid-tile>

  <mat-grid-tile colspan="2" rowspan="2">
    <ul class="stacked-slide-toggles">
      <li>
        <mat-slide-toggle name="grafana" class="slide-toggle stacked-toggle" required *ngIf="globalAdmin" [(ngModel)]="grafana" (change)="getConfigValue($event)" id="grafana"  matTooltip="Make a grafana instance available">Grafana</mat-slide-toggle>
      </li>
      <li>
        <mat-slide-toggle name="latam" class="slide-toggle stacked-toggle" required *ngIf="globalAdmin" [(ngModel)]="latam" (change)="getConfigValue($event)" id="latam" matTooltip="Indicator that this organization belongs to Latin America.">LATAM</mat-slide-toggle>
      </li>
    </ul>
  </mat-grid-tile>

  <mat-grid-tile [ngClass]="{'darkModeIcon': darkModeService.darkMode}" colspan="2" rowspan="2">
    <mat-icon *ngIf="!new && !edit && globalAdmin" (click)="changeModoEdit()" matTooltip="Edit">edit</mat-icon>
    <mat-icon *ngIf="!new && edit && globalAdmin" (click)="save()" matTooltip="Save">save</mat-icon>
    <mat-icon *ngIf="!new && edit && globalAdmin" (click)="cancel()" matTooltip="Cancel">cancel</mat-icon>
  </mat-grid-tile>

</mat-grid-list>
